import {useEffect,useRef,useState} from 'react'
import {apiGet} from '../api/client'
import type {Envelope} from '../api/types'

/** Only the file ID is persisted. Reauthorize every URL renewal; one automatic
 * retry per consecutive load failure, renewed again after a successful load. */
export default function RequirementImagePreview({projectId,fileId,alt}:{projectId?:string;fileId:string;alt:string}){
 const [url,setUrl]=useState(''),[state,setState]=useState('loading'),alive=useRef(true),renewed=useRef(false),sequence=useRef(0)
 const load=async()=>{
  if(!alive.current)return
  const request=++sequence.current
  if(!projectId){setState('failed');return}
  setState('loading')
  try{
   const result=await apiGet<Envelope<{download_url:string|null}>>(`/projects/${encodeURIComponent(projectId)}/materials/${encodeURIComponent(fileId)}/reference`)
   if(!alive.current||request!==sequence.current)return
   if(!result.data.download_url)throw Error()
   setUrl(result.data.download_url);setState('ready')
  }catch{if(alive.current&&request===sequence.current)setState('failed')}
 }
 useEffect(()=>{alive.current=true;renewed.current=false;setUrl('');void load();return()=>{alive.current=false;sequence.current++}},[projectId,fileId])
 const manualRetry=(event:React.MouseEvent|React.KeyboardEvent)=>{event.preventDefault();event.stopPropagation();renewed.current=false;void load()}
 if(state!=='ready')return <span className="preview-image-state project-requirement-image" role="status"><span>{state==='loading'?'正在加载图片…':'图片加载失败，请重试'}</span>{state==='failed'?<span role="button" tabIndex={0} className="preview-image-retry" onClick={manualRetry} onKeyDown={event=>{if(event.key==='Enter'||event.key===' ')manualRetry(event)}}>重新加载</span>:null}</span>
 const request=sequence.current
 return <img key={url} className="project-requirement-image" src={url} alt={alt} loading="lazy" onLoad={()=>{if(alive.current&&request===sequence.current)renewed.current=false}} onError={()=>{
  if(!alive.current||request!==sequence.current)return
  if(!renewed.current){renewed.current=true;void load()}else setState('failed')
 }}/>
}
